import { toRGBA } from "./utils";

const bugs = [155, 155, 155];
const b = (opacity: number = 1) => toRGBA(bugs[0], bugs[1], bugs[2], opacity);

export default b;
